import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import {
  fetchReducer,
  themeReducer,
  authorisationReducer,
} from 'nallian-shared-ui/lib/reducers';
import { toaster } from 'nallian-shared-ui/lib/components';
import { filtersReducer } from 'nallian-shared-ui/lib/hoc/redux-filters';
import { listReducer } from 'nallian-shared-ui/lib/hoc/redux-list';
import { sortingReducer } from 'nallian-shared-ui/lib/hoc/redux-sorting';

const rootReducer = combineReducers({
  form,
  auth: authorisationReducer,
  toastr: toaster.toasterReducer,
  repository: fetchReducer,
  theme: themeReducer,

  filters: filtersReducer,
  sorting: sortingReducer,
  lists: listReducer,
});

export default rootReducer;
